import { useState, type FormEvent } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { resetPassword } from '../api/endpoints.js';
import { errorMessage } from '../api/client.js';

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') ?? '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  const mismatch = confirm.length > 0 && password !== confirm;
  const tooShort = password.length > 0 && password.length < 8;

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setSubmitting(true);
    try {
      await resetPassword(token, password);
      setDone(true);
      setTimeout(() => navigate('/login', { replace: true }), 1800);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-card__brand">
          <span className="sidebar__logo">◆</span>
          <span>Tips CRM</span>
        </div>
        <h1>Choose a new password</h1>

        {!token ? (
          <>
            <div className="form-error" role="alert">This reset link is missing its token.</div>
            <p className="muted" style={{ marginTop: 16 }}>
              <Link to="/forgot-password">Request a new link</Link>
            </p>
          </>
        ) : done ? (
          <p className="muted">Password updated. Redirecting you to sign in…</p>
        ) : (
          <form onSubmit={handleSubmit} className="login-form">
            <label className="field">
              <span className="field__label">New password</span>
              <input
                className="field__input"
                type="password"
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoFocus
                minLength={8}
              />
            </label>
            <label className="field">
              <span className="field__label">Confirm password</span>
              <input
                className="field__input"
                type="password"
                autoComplete="new-password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
              />
            </label>
            {tooShort && <div className="form-error">Password must be at least 8 characters.</div>}
            {mismatch && <div className="form-error">Passwords do not match.</div>}
            {error && <div className="form-error" role="alert">{error}</div>}
            <button
              type="submit"
              className="btn btn--primary btn--block"
              disabled={submitting || !password || !confirm || mismatch || tooShort}
            >
              {submitting ? 'Updating…' : 'Update password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
